<template>
  <div class="comment__audit-compare-content">
    <UserReferenceTooltip
      v-if="beforeOwner"
      :user="beforeOwner"
    >
      <span class="link is-medium-500 is-opacity">{{ beforeOwnerFullName }}</span>
    </UserReferenceTooltip>
    <span
      v-else
      class="link is-medium-500 is-opacity"
      >{{ beforeOwnerFullName }}</span
    >
    <icon
      data="@icon/arrow-to.svg"
      :fill="true"
      width="var(--icon-24)"
      height="var(--icon-24)"
      color="var(--monochrome05to04)"
    />
    <UserReferenceTooltip
      v-if="afterOwner"
      :user="afterOwner"
    >
      <span class="link is-medium-500">{{ afterOwnerFullName }}</span>
    </UserReferenceTooltip>
    <span
      v-else
      class="link is-medium-500"
      >{{ afterOwnerFullName }}</span
    >
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"

import UserReferenceTooltip from "@/components/Reference/component/UserReferenceTooltip.vue"

import { Comment, User } from "@/models"

const props = defineProps<{
  comment: Comment
}>()

const beforeOwner = computed(() => {
  const owner = props.comment.before?.owner ?? null
  if (!owner) return null
  return User.create(owner)
})

const beforeOwnerFullName = computed(() =>
  beforeOwner.value ? `@${beforeOwner.value.firstName} ${beforeOwner.value.lastName}` : "Unassigned"
)

const afterOwner = computed(() => {
  const owner = props.comment.after?.owner ?? null
  if (!owner) return null
  return User.create(owner)
})

const afterOwnerFullName = computed(() =>
  afterOwner.value ? `@${afterOwner.value.firstName} ${afterOwner.value.lastName}` : "Unassigned"
)
</script>
